import { combineReducers } from 'redux'
import { authReducer } from '../slices/authSlice'
import { configsReducer } from '../slices/configsSlice'
import { userReducer } from '../slices/userSlice'
import { modalReducer } from '../slices/modalSlice'
import { sideBarReducer } from '../slices/sideBarSlice'
import { rightBarReducer } from '../slices/rightBarSlice'
import { settingsReducer } from '../slices/settingsSlice'
import { licenseReducer } from '../slices/licenseSlice'
import { infoReducer } from '../slices/infoSlice'
import { logsReducer } from '../slices/logsSlice'
import { tableViewReducer } from '../slices/tableVieSlice'
import { notificationsReducer } from '../slices/notificationsSlice'
import { productsUtcOffsetReducer } from '../slices/productsUtcOffsetSlice'
import { schedulesReducer } from '../slices/schedulesSlice'
import { productsReducer } from '../slices/productsSlice'
import { actionsReducer } from '../slices/actionsSlice'
import { descriptionWindowReducer } from '../slices/descriptionWindowSlice'
import { configChangeHistoryReducer } from '../slices/configChangeHistorySlice'
import { ruleCardReducer } from '../slices/ruleCardSlice'

export const rootReducer = combineReducers({
    auth: authReducer,
    user: userReducer,
    modal: modalReducer,
    rightBar: rightBarReducer,
    products: productsReducer,
    configurations: configsReducer,
    licence: licenseReducer,
    info: infoReducer,
    logs: logsReducer,
    notifications: notificationsReducer,
    tableView: tableViewReducer,
    sideBar: sideBarReducer,
    actions: actionsReducer,
    schedules: schedulesReducer,
    settings: settingsReducer,
    productsUtcOffset: productsUtcOffsetReducer,
    descriptionWindow: descriptionWindowReducer,
    configChangesHistory: configChangeHistoryReducer,
    ruleCard: ruleCardReducer,
})